module.exports = "/fonts/HelveticaNeueLight.woff?212707c7122923a41b2c05e4e7cf8ddb";